import { Component, ViewChild, AfterViewInit, ApplicationRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MultilevelNodes, ExpandedRTL, ExpandedLTR, NgMaterialMultilevelMenuComponent } from 'ng-material-multilevel-menu';
import { Auth, signOut } from '@angular/fire/auth';
import { SharedService } from './shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { HelpSupportModalComponent } from './modules/help-and-support/modals/help-support-modal/help-support-modal.component';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { IntroVideoModalComponent } from './shared/modals/intro-video-modal/intro-video-modal.component';
import { PlatformLocation } from '@angular/common';
import { StepInstallIosModalComponent } from './shared/modals/step-install-ios-modal/step-install-ios-modal.component';
import { UsersService } from './modules/management/components/tabs/components/users/users.service';
import { LikesService } from './shared/likes.service';
import { ProgramBuilderMainService } from './modules/creation-center/components/program-builder-main/program-builder-main.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DashboardService } from './modules/learning-center/components/my-dashboard/my-dashboard.service';
import { AnalyticsService } from './modules/analytics/components/analytics/analytics.service';
import { PostHogService } from './shared/services/posthog.service';
import { ImpersonationService } from './shared/services/impersonation.service';
import {
	POSTHOG_EVENT_APPLICATION_STARTED,
	POSTHOG_EVENT_COURSE_BUILDER_ADMIN_LOGIN,
	POSTHOG_EVENT_AUDIT_ADMIN_LOGIN
} from './shared/constants/posthog-events.constants';

// import { MobileInfoModalComponent } from './mobile-info-modal/mobile-info-modal.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [ExpandedRTL, ExpandedLTR,
		trigger('fadeInRight', [
			state('void', style({ opacity: 0, transform: 'translateX(-20px)' })), // Start from left
			transition(':enter', [
				animate('300ms ease-in', style({ opacity: 1, transform: 'translateX(0)' })), // Move to right
			]),
			transition(':leave', [
				animate('300ms ease-out', style({ opacity: 0, transform: 'translateX(-20px)' })), // Move to left
			]),
		]),
	]
})
export class AppComponent {
	hoverState = false;
	fadeInRight = false;
	title = 'ignite-retail-trial';
	@ViewChild(NgMaterialMultilevelMenuComponent)
	menu!: NgMaterialMultilevelMenuComponent;
	showMenu: any;
	activeItem: any = null;
	selectedIndex: number | undefined;
	showdropdown: any;
	jobsAvailable: any;
	appitems: any[] = [];
	config = {
		paddingAtStart: true,
		classname: "side-nav-menu",
		fontColor: "#000",
		// selectedListFontColor: "#7366ff",
		highlightOnSelect: true,
		useDividers: false,
		collapseOnSelect: true,
		selectedListFontColor: "white",
		selectedlistBackgroundColor: "#130f26",
		rtlLayout: true,
		customTemplate: true,
	};
	defaultSelectedItem: any;
	blockLoader: string = 'blockLoader';
	hasActiveProgram: boolean = false;
	activePrograms: any = [];
	getRoleJobsSub: any;
	showPwaPrompt: boolean = false;
	deferredPrompt: any = null;
	askedOnce: boolean = false;
	closeInstallBanner = false;
	androidOrIos: any;
	samsungBrowser = false;
	deviceInfo: any;
	isMobile: boolean = false;
	isDesktop: boolean = false;
	isTablet: boolean = false;
	isiPhone: boolean = false;
	isIOSPWA: any;
	isPipOpened: boolean = false;
	customToastText: string = "";
	vttFileGenerationSub: any;
	userId: string;
	isImpersonating: boolean = false;
	impersonatedUserLabel: string = "";
	vttGenerationDetailsGlobal: any = {
		status: "pending",
		techStatus: "",
		message: ""
	};
	userData: any;
	menuRouteSub: Subscription | null = null;

	constructor(
		private auth: Auth,
		private spinner: NgxSpinnerService,
		private router: Router,
		private sharedService: SharedService,
		private dialogRef: MatDialog,
		private deviceDetectorService: DeviceDetectorService,
		private analyticsService: AnalyticsService,
		private usersService: UsersService,
		private likesService: LikesService,
		private appRef: ApplicationRef,
		private dashboardService: DashboardService,
		private programBuilderMainService: ProgramBuilderMainService,
		private posthog: PostHogService,
		private impersonationService: ImpersonationService
	) {
		this.userId = localStorage.getItem('userId') ?? "";

		this.sharedService.activePrograms$.subscribe(activePrograms => {
			// console.log(activePrograms);
			this.activePrograms = activePrograms;
			if (activePrograms.length >= 1) {
				this.hasActiveProgram = true;
			} else {
				this.hasActiveProgram = false;
			}

			this.sortActiveProgramsByAccessOrder();
		});

		const vttFileObs = this.programBuilderMainService.vttFileGenObs();
		if (vttFileObs) {
			this.vttFileGenerationSub = vttFileObs.subscribe(async genDetails => {
				// console.log("sub update!");
				if (genDetails) {
					console.log(this.vttGenerationDetailsGlobal);
					if (genDetails['message'] !== this.vttGenerationDetailsGlobal.message) {
						this.customToastText = genDetails['message'];
					}
					this.vttGenerationDetailsGlobal = genDetails;
					this.appRef.tick();
				}
			});
		}
	}

	selectedItem(selectedItem: any) {
		// console.log('selectedItem', selectedItem);
		this.appitems.forEach((item: any) => {
			item.isActive = item.id === selectedItem.id;
			// console.log('item', item);
		});
		localStorage.setItem('selectedMenuItem', JSON.stringify(selectedItem));

		// Capture PostHog event when user clicks on Course builder admin login
		if (selectedItem.label === 'Course builder') {
			const userEmail = localStorage.getItem('username');
			const role = localStorage.getItem('roleId');

			this.posthog.capture(POSTHOG_EVENT_COURSE_BUILDER_ADMIN_LOGIN, {
				'User email': userEmail,
				'device_type': 'Web',
				'role': role
			});
		}

		// Capture PostHog event when user clicks on Audit builder admin login
		if (selectedItem.label === 'Audit builder') {
			const userEmail = localStorage.getItem('username');
			const role = localStorage.getItem('roleId');

			this.posthog.capture(POSTHOG_EVENT_AUDIT_ADMIN_LOGIN, {
				'User email': userEmail,
				'device_type': 'Web',
				'role': role
			});
		}
		if (selectedItem.link) {
			this.router.navigate([selectedItem.link]);
		}
	}


	async ngOnInit() {
		this.defaultSelectedItem = this.appitems[1];
		this.updateImpersonationUiState();

		this.detectPlatform();

		//add to home screen show for 6 seconds if user is logged in.
		if (this.userId) {
			setTimeout(() => {
				this.closeBanner();
			}, 6000);
		}

		if (this.userId) {
			this.posthog.identify(this.userId);
			this.userData = await this.dashboardService.getUserData();
			if (this.userData) {
				localStorage.setItem("roleId", this.userData.roleId);
			}
		}
		this.posthog.capture(POSTHOG_EVENT_APPLICATION_STARTED);
		await this.getSideMenuItems();
		this.menuRouteSub = this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				this.syncActiveMenuWithRoute();
			});

		this.usersService.initTypesenseClient();
		// console.log('activeItem', this.activeItem)

		this.likesService.getPIPValue().subscribe(value => {
			if (value === 'minimize') {
				this.isPipOpened = true;
			} else {
				this.isPipOpened = false;
			}
		});

		const orgId = this.getLocalOrgId();
		if (orgId) {
			console.log(orgId);
			const orgData: any = await this.analyticsService.getOrgData(orgId);
			console.log(orgData);
			if (!orgData.active) {
				await this.sharedService.logOut();
			}
		}
	}

	getLocalOrgId() {
		return localStorage.getItem('orgId');
	}

	checkIfIOSPWA() {
		if (window.matchMedia('(display-mode: standalone)').matches) {
			// The app is running in standalone mode on iOS
			this.isIOSPWA = true;
		} else {
			// The app is not running in standalone mode on iOS
			this.isIOSPWA = false;
		}

		// console.log('this.isIOSPWA',this.isIOSPWA)
	}


	getInstallPrompt(): void {
		// console.log('getInstallPrompt');
		// console.log('window', window);
		// console.log('this.showPwaPrompt', this.showPwaPrompt);
		//addEventListener is not working for iOS
		//And for the manual prompt
		window.addEventListener('beforeinstallprompt', (e) => {
			// console.log('eeee',e)
			let displayMode = 'browser tab';
			if (window.matchMedia('(display-mode: standalone)').matches) {
				// console.log('iiiii')
				displayMode = 'standalone';
			}
			// Log launch display mode to analytics
			//   console.log('DISPLAY_MODE_LAUNCH:', displayMode);
			e.preventDefault();
			this.deferredPrompt = e;
			//   console.log('beforeinstallprompt!');
			this.showPwaPrompt = true;
			//   console.log('this.showPwaPrompt', this.showPwaPrompt)
		});
	}

	addToHome() {
		// console.log('clicked add to home btn')
		this.deferredPrompt.prompt();
		this.deferredPrompt.userChoice
			.then((choiceResult: any) => {
				if (choiceResult.outcome === 'accepted') {
					// console.log('User accepted the prompt');
				} else {
					// console.log('User dismissed the prompt');
					this.closeBanner();
				}
				this.deferredPrompt = null;
			});
	};


	closeBanner() {
		this.closeInstallBanner = true;
	}

	detectPlatform() {
		// console.log('this.deviceDetectorService.device', this.deviceDetectorService);
		this.isMobile = this.deviceDetectorService.isMobile() && this.deviceDetectorService.device === 'Android';
		if (this.isMobile) this.getInstallPrompt();
		this.isTablet = this.deviceDetectorService.isTablet();
		this.isDesktop = this.deviceDetectorService.isDesktop();
		this.isiPhone = this.deviceDetectorService.isMobile() && this.deviceDetectorService.device === 'iPhone';
		if (this.isiPhone) this.checkIfIOSPWA();
		// console.log('isMobile', this.isMobile);
		// console.log('isTablet', this.isTablet);
		// console.log('isiPhone', this.isiPhone);
		// console.log('isDesktop', this.isDesktop);
	}

	ngOnDestroy() {
		this.getRoleJobsSub.unsubscribe();
		this.vttFileGenerationSub.unsubscribe();
		if (this.menuRouteSub) {
			this.menuRouteSub.unsubscribe();
		}
	}

	CheckLogoutRoute() {
		return this.router.url.includes("/login") || this.router.url.includes("/programs") || this.router.url.includes("/forgot-password") || this.router.url.includes("/reset-password") || this.isMandatoryPasswordChangeRoute();
	}

	isMandatoryPasswordChangeRoute(): boolean {
		// return this.router.url.startsWith('/change-password')
		// 	&& localStorage.getItem('mustChangePassword') === 'true'
		// 	&& localStorage.getItem('isImpersonating') !== 'true';
		return false;
	}

	async onClickLogout() {
		this.sharedService.logOut();
		this.showMenu = false;
	}

	async stopImpersonation() {
		try {
			await this.spinner.show("blockLoader");
			await this.impersonationService.stopImpersonation();
			this.setActiveMenuByLabel("Admin");
			await this.spinner.hide("blockLoader");
			window.location.href = '/management';
		} catch (err) {
			await this.spinner.hide("blockLoader");
			console.log("Unable to stop impersonation", err);
		}
	}

	updateImpersonationUiState() {
		this.isImpersonating = this.impersonationService.isImpersonating();

		if (this.isImpersonating) {
			const name = localStorage.getItem('firstName') || "";
			const email = localStorage.getItem('username') || "";
			this.impersonatedUserLabel = `${name} (${email})`;
		}
	}

	changeFilterRoute() {
		return this.router.url.includes("/change-filter") || this.router.url.includes("/team-analytics") || this.router.url.includes("/management-analytics");
	}

	getObservableRes(obs: any) {
		return new Promise((resolve) => {
			obs.subscribe((res: any) => {
				resolve(res);
			});
		});
	}

	getClass(item: any) {
		// console.log('item.faIcon', item.faIcon)
		// console.log('item.faIcon', )
		return item.faIcon;
	}

	showHideMenu() {
		// console.log('close')
		this.showMenu = true
	}

	closeMenu() {
		// console.log('close')
		this.showMenu = false
	}

	showDropdownItemsMenu(i: any, item: any) {
		// console.log('item', item)
		if (item.hasChilden) {
			this.showdropdown = !this.showdropdown
		}

		if (item.label === "Logout") {
			this.onClickLogout()
		}

		if (item.label === "Help") {
			this.showMenu = false;
			this.openHelpSupportModal();
		}
	}

	programPageRoute() {
		return this.router.url.includes("/programs")
	}

	historyPageRoute() {
		return this.router.url.includes("/history")
	}

	AnalyticsPageRoute() {
		return this.router.url.includes("/admin-analytics")
	}

	personalAnalyticsPageRoute() {
		return this.router.url.includes("/analytics")
	}

	libraryPageRoute() {
		return this.router.url.includes("/my-library")
	}

	ProfilePageRoute() {
		return this.router.url.includes("/profile-page")
	}

	async getSideMenuItems() {
		const roleId = localStorage.getItem("roleId") ?? '';
		if (roleId) {
			// await this.spinner.show("blockLoader");
			this.getRoleJobsSub = this.sharedService.getRoleJobs(roleId)?.subscribe(async response => {
				// console.log('getRoleJobs subscription: ', response);
				if (response && 'jobs' in response) {
					this.jobsAvailable = response['jobs'];
					this.createSideMenu();

					let storedSelectedItem: any = localStorage.getItem('selectedMenuItem');
					// console.log('storedSelectedItem', storedSelectedItem)

					const selectedItem = JSON.parse(storedSelectedItem);
					// console.log(selectedItem);
					if (storedSelectedItem) {
						if (selectedItem?.parentItem === 'learn') {
							this.appitems[0]['isActive'] = true;
							this.appitems[0]['expanded'] = true;
						} else if (selectedItem?.parentItem === 'creation') {
							this.appitems[3]['isActive'] = true;
							this.appitems[3]['expanded'] = true;
						} else {
							this.appitems.forEach((item: any) => {
								item.isActive = item.link === selectedItem.link;
							});
						}
					}
					this.syncActiveMenuWithRoute();

					// console.log(this.appitems);
				} else {
					await this.sharedService.logOut();
					return;
				}
			});
		}
	}

	createSideMenu() {
		try {
			let appItems: any = [];
			for (let i = 0; i < this.jobsAvailable.length; i += 1) {
				let job = this.jobsAvailable[i];

				if (i === 0 && job.subMenu.length >= 1) {
					if (this.isSubjobActive(i)) {
						appItems.push({
							label: "Learning Centre",
							faIcon: "flaticon-learning",
							link: "/my-dashboard",
							items: []
						});

						let subMenu = job.subMenu;
						for (let j = 0; j < subMenu.length; j += 1) {
							if (j === 0 && subMenu[j].active) {
							} else if (j === 1 && subMenu[j].active) {
								appItems[0].items?.push({
									label: "Learn",
									isDropdownItem: true,
									faIcon: "lens",
									parentItem: 'learn',
									onSelected: () => {
										this.sideMenuLearnClick();
									}
								});
							} else if (j === 2 && subMenu[j].active) {
								appItems[0].items?.push({
									label: "History",
									link: "/history",
									parentItem: 'learn',
									isDropdownItem: true,
									faIcon: "lens"
								});
							} else if (j === 3 && subMenu[j].active) {
								appItems[0].items?.push({
									label: "Library",
									link: "/my-library",
									parentItem: 'learn',
									isDropdownItem: true,
									faIcon: "lens"
								});
							} else if (j === 4 && subMenu[j].active) {
								appItems[0].items?.push({
									label: "Personal Analytics",
									link: "/analytics",
									parentItem: 'learn',
									isDropdownItem: true,
									faIcon: "lens"
								});
							}
						}
					}
				} else if (i === 1 && job.active) {
					appItems.push({
						label: "Store Visitation",
						faIcon: "flaticon-navigation-1",
						link: "/audit-visitation"
					});
				} else if (i === 2 && job.active) {
					appItems.push({
						label: "Admin",
						faIcon: "flaticon-setting",
						link: "/management"
					});
				} else if (i === 3 && job.subMenu.length >= 1) {
					if (this.isSubjobActive(i)) {
						appItems.push({
							label: "Creation Center",
							faIcon: "flaticon-quiz-4-1",
							link: "/program-builder-main",
							items: []
						});

						let subMenu = job.subMenu;
						for (let j = 0; j < subMenu.length; j += 1) {
							if (j === 0 && subMenu[j].active) {
								appItems[appItems.length - 1].items?.push({
									label: "Program builder",
									link: "/program-builder-main",
									faIcon: "lens",
									parentItem: 'creation',
								});
							} else if (j === 1 && subMenu[j].active) {
								appItems[appItems.length - 1].items?.push({
									label: "Course builder",
									link: "/course-builder",
									faIcon: "lens",
									parentItem: 'creation',
								});
							} else if (j === 2 && subMenu[j].active) {
								appItems[appItems.length - 1].items?.push({
									label: "Audit builder",
									link: "/audit-builder",
									faIcon: "lens",
									parentItem: 'creation',
								});
							}
						}
					}
				} else if (i === 4 && job.active) {
					appItems.push({
						label: "Rewards",
						faIcon: "flaticon-grade-1-1",
						link: "/rewards",
					});
				} else if (i === 5 && job.active) {
					appItems.push({
						label: "Team Analytics",
						faIcon: "flaticon-learning",
						link: "/admin-analytics",
					});
				}
			}

			appItems.push({
				label: "Help",
				faIcon: "flaticon-quiz-4-1",
				onSelected: () => {
					this.openHelpSupportModal();
				}
				// link: "/help",
				// items: []
			});

			appItems.push({
				label: "Change Password",
				faIcon: "fa fa-lock",
				link: "/change-password"
			});

			appItems.push({
				label: "Logout",
				faIcon: "flaticon-switch",
				onSelected: () => {
					console.log('asdfghjk')
					this.onClickLogout();
					// console.log('asdfghjk')
				}
			});

			this.appitems = appItems;
		} catch (err) {
			console.log("initSideMenu error", err);
		}
	}

	setActiveMenuByLabel(label: string, expanded: boolean = false) {
		let selectedItem: any = null;
		this.appitems.forEach((item: any) => {
			const isActive = item.label === label;
			item.isActive = isActive;
			if (item.items?.length) {
				item.expanded = isActive && expanded;
			}
			if (isActive) {
				selectedItem = item;
			}
		});

		if (selectedItem) {
			localStorage.setItem('selectedMenuItem', JSON.stringify(selectedItem));
		}
	}

	syncActiveMenuWithRoute() {
		if (!this.appitems?.length) {
			return;
		}

		const url = (this.router.url || "").split("?")[0];
		const isLearningRoute = url.startsWith("/my-dashboard")
			|| url.startsWith("/programs")
			|| url.startsWith("/history")
			|| url.startsWith("/my-library")
			|| url.startsWith("/analytics");
		const isAdminRoute = url.startsWith("/management") || url.startsWith("/tabs");
		const isCreationRoute = url.startsWith("/program-builder-main")
			|| url.startsWith("/course-builder")
			|| url.startsWith("/audit-builder");
		const isTeamAnalyticsRoute = url.startsWith("/admin-analytics")
			|| url.startsWith("/team-analytics")
			|| url.startsWith("/management-analytics")
			|| url.startsWith("/change-filter");
		const isChangePasswordRoute = url.startsWith("/change-password");

		if (isLearningRoute) {
			this.setActiveMenuByLabel("Learning Centre", true);
		} else if (url.startsWith("/audit-visitation")) {
			this.setActiveMenuByLabel("Store Visitation");
		} else if (isAdminRoute) {
			this.setActiveMenuByLabel("Admin");
		} else if (isCreationRoute) {
			this.setActiveMenuByLabel("Creation Center", true);
		} else if (url.startsWith("/rewards")) {
			this.setActiveMenuByLabel("Rewards");
		} else if (isTeamAnalyticsRoute) {
			this.setActiveMenuByLabel("Team Analytics");
		} else if (isChangePasswordRoute) {
			this.setActiveMenuByLabel("Change Password");
		}
	}

	isSubjobActive(index: number) {
		const subMenu = this.jobsAvailable[index].subMenu;
		for (let i = 0; i < subMenu.length; i += 1) {
			if (subMenu[i].active) {
				return true;
			}
		}
		return false;
	}

	sideMenuLearnClick() {
		if (this.hasActiveProgram) {
			this.router.navigate(['programs'], {
				state: {
					progressId: this.activePrograms[0].id
				}
			});
		} else {
			this.router.navigate(['my-library']);
		}
	}

	hideDrawer(item: any) {
		// console.log('item', item)
		// if (!item.hasChilden) {
		this.showMenu = false
		// }
	}

	closeDrawer(item: any) {
		// console.log('item', item)
		if (item.link && !item?.hasChilden) {
			this.showMenu = false
		}
	}

	onClickActionMobile(itemLabel: string) {
		if (itemLabel === 'Learn') {
			this.sideMenuLearnClick();
		}
	}

	openHelpSupportModal() {
		// const isNewVisitor = localStorage.getItem('newVisitorIntroduction') === 'true';
		// localStorage.setItem('newVisitorIntroduction', isNewVisitor ? 'false' : 'true');
		const diaogRef = this.dialogRef.open(HelpSupportModalComponent, {
			minWidth: '60%',
			// maxHeight: '80vh',
			// height: 'fit-content',
			panelClass: 'hlp-sprt-modal'
		});
	}

	toggleAnimation(value: boolean) {
		this.fadeInRight = value;
	}

	clickForIosAlert() {
		const diaogRef = this.dialogRef.open(StepInstallIosModalComponent, {
			maxWidth: '100vw',
			minWidth: 'fit-content',
		});
	}

	goToDashboard() {
		this.router.navigate(['my-dashboard']);
		this.showMenu = false;
	}

	sortActiveProgramsByAccessOrder() {
		this.activePrograms.sort(function sortByAccessOrder(programA: any, programB: any) {
			if (programA.lastUpdatedAt > programB.lastUpdatedAt) {
				return -1;
			} else if (programA.lastUpdatedAt < programB.lastUpdatedAt) {
				return 1;
			}

			return 0;
		});
	}

	async closeCustomToast() {
		this.customToastText = "";

		if (this.vttGenerationDetailsGlobal.status === "resolved") {
			await this.programBuilderMainService.clearGenerationDetails(this.userId);
		}

		this.vttGenerationDetailsGlobal = {
			status: "pending",
			techStatus: "",
			message: ""
		};
	}
}
